import RestClient from '../RestClient/RestClient';
import { RestConfig, getHostConfig } from '../Common/RestConfig';
import SavedItemsApiConstants from './SavedItemsApiConstants';
import AccountApiConstants from '../Account/AccountApiConstants';

const getEndPoint = (payload) => {
    let endPoint = SavedItemsApiConstants.SAVED_ITEMS_NEW;
    if (payload && payload.cartSavedItems) {
        endPoint = SavedItemsApiConstants.CART_SAVED_ITEMS;
    }

    return endPoint;
};

const getPayloadParam = (payload) => {
    let payloadParams = payload;
    if (payload && payload.cartSavedItems) {
        payloadParams = payload.params;
    }

    return payloadParams;
};

/**
 * Function to add items to SAVEDITEMS list.
 * @param params : Takes {items: [
          {
            ppId: productId,
            quantity: quantity || 1
          }]
      }
 * @returns {Promise.<T>|*}
 */
export const addSavedItems = (params) => {
    let config = RestConfig.v5AccountConfig();
    const endPoint = getEndPoint(params.payload);
    const payloadParams = getPayloadParam(params.payload);
    config.url = `${AccountApiConstants.CAM_BASE}/${params.accountId}/${endPoint}`;
    config = getHostConfig(config);
    config.isDPClusterRequired = true;
    config.excludes = params.payload.excludes;
    config.xClientSource = params.payload.xClientSource;
    config.params = payloadParams;
    config.accessToken = params.accessToken;

    return RestClient.post(config).then((res) => res);
    // catch not required already handled in ResClient/FetchHelper.js
};

export const getAllSavedItems = (params) => {
    let config = RestConfig.v5AccountConfig();
    const endPoint = getEndPoint(params.payload);
    const payloadParams = getPayloadParam(params.payload);
    config.url = `${AccountApiConstants.CAM_BASE}/${params.accountId}/${endPoint}`;
    config.excludes = params.payload.excludes;
    config.xClientSource = params.payload.xClientSource;
    config.params = payloadParams;
    config = getHostConfig(config);
    config.accessToken = params.accessToken;
    if (
        params.payload &&
        params.payload.guestSavedItems &&
        params.payload.savedItemsData &&
        params.payload.savedItemsData.length > 0
    ) {
        config.guestSavedItems = true;
        config.savedItems = params.payload.savedItemsData;
    }

    return RestClient.get(config);
};

export const removeSavedItem = (params) => {
    let config = RestConfig.v5AccountConfig();
    const endPoint = getEndPoint(params.payload);
    const payloadParams = getPayloadParam(params.payload);
    config = getHostConfig(config);
    config.url = `${AccountApiConstants.CAM_BASE}/${params.accountId}/${endPoint}`;
    config.url = `${config.url}/${payloadParams}`;
    config.isDPClusterRequired = true;
    config.accessToken = params.accessToken;
    return RestClient.delete(config).then((res) => res);
    // catch not required already handled in RestClient/FetchHelper.js
};
